import { useSelector } from 'react-redux';

import { selectFilter } from '../selectors';
import { buildFilterMarkup } from './utils';
import { filterItems } from './constants';

import './filter.css'

export default function Filter({ mode }) {
    const filter = useSelector((state) => selectFilter(state));
    const items = filterItems[mode];

    return (
        buildFilterMarkup(items, filter)
    );
}
